import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

interface CreatePracticeDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  practiceName: string;
  practiceDescription: string;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onSave: () => void;
}

/**
 * Dialog for creating a new practice before saving sets
 */
export function CreatePracticeDialog({
  isOpen,
  onOpenChange,
  practiceName,
  practiceDescription,
  onNameChange,
  onDescriptionChange,
  onSave,
}: CreatePracticeDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create New Practice</DialogTitle>
          <DialogDescription>
            Enter details for your new practice before saving the sets.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 mt-3">
          <Input
            placeholder="Practice Name"
            value={practiceName}
            onChange={(e) => onNameChange(e.target.value)}
          />
          <Input
            placeholder="Description"
            value={practiceDescription}
            onChange={(e) => onDescriptionChange(e.target.value)}
          />
        </div>

        <div className="flex justify-end mt-4 space-x-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onSave}>
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

